import { render, staticRenderFns } from "./QuestionEditInfo.vue?vue&type=template&id=b535ca90&"
import script from "./QuestionEditInfo.vue?vue&type=script&lang=js&"
export * from "./QuestionEditInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuestionEditInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports